export const PetdaysApi = {
  products: `
query getProducts(
    $search: String
    $filter: ProductAttributeFilterInput
    $sort: ProductAttributeSortInput
    $pageSize: Int
    $currentPage: Int
  ) {
    products(
      search: $search
      filter: $filter
      sort: $sort
      pageSize: $pageSize
      currentPage: $currentPage
    ) {
      items {
        ...ProductInterfaceField
        ...ConfigurableProductField
      }
      aggregations{
        attribute_code
        count
        label
        options {
          count
          label
          value
          swatch_data {
              type
              value
          }
        }
        
        position
      }
      sort_fields {
        default
        options {
          label
          value
        }
      }
      total_count
      page_info {
        current_page
        page_size
        total_pages
      }
      
    }
  }
  fragment ProductInterfaceField on ProductInterface {
    __typename
    sku
    uid
    name
    url_key
    link_shopee
  link_tiktok
    stock_status
    id
    categories {
      __typename
      name
      url_key
      url_path
      level
      uid
      icon_image
      image
      path
    }
       sales_qty
    shirt_back
    new_from_date
    new_to_date
    rating_summary
    review_count
    thumbnail {
      url
      position
    }
    image {
      url
    }
    media_gallery {
      __typename
      disabled
      label
      url
      position
    }
    price_range {
      ...PriceRangeField
    }
    ...CustomField
  }
  fragment CustomField on ProductInterface {
    color
     daily_sale {
    sale_price
    end_date
    entity_id
    sale_qty
    start_date
    saleable_qty
    sold_qty
    title
    __typename
  }
   
  }
  fragment ConfigurableProductField on ConfigurableProduct {
      configurable_options {
         attribute_code
          label
          uid
          attribute_uid
          values {
            label
            uid
            default_label
            swatch_data {
              value
          }
          }
      }
      configurable_product_options_selection {
        __typename
        configurable_options {
          attribute_code
          label
          uid
          values {
            __typename
            uid
            label
            is_use_default
            is_available
            swatch {
              ...SwatchDataField
            }
          }
        }
      }
      variants {
        attributes {
          code
          label
          uid
        }
        product {
          shirt_back
          stock_status
          __typename
          special_price
          ...CustomField
          price_range {
            ...PriceRangeField
          }
          media_gallery {
        url
        position
        __typename
      ... on ProductVideo{
        video_content {
          media_type
          video_description
          video_metadata
          video_provider
          video_title
          video_url
        }
      }
    }
          sku
          name
          url_key
          image {
            url
            label
          }
          thumbnail {
            url
            position
          }
          uid
        }
      }
    }
    fragment SwatchDataField on SwatchDataInterface {
      __typename
      ... on ColorSwatchData {
        __typename
        value
      }
      ... on ImageSwatchData {
        __typename
        value
      }
      ... on TextSwatchData {
        __typename
        value
      }
    }
  fragment PriceRangeField on PriceRange {
    __typename
    maximum_price {
      ...ProductPriceField
    }
    minimum_price {
      ...ProductPriceField
    }
  }

  fragment ProductPriceField on ProductPrice {
    discount {
      amount_off
      percent_off
    }
    final_price {
      currency
      value
    }
    regular_price {
      currency
      value
    }
  }
`,
  aside: `
query getProducts(
  $search: String
  $filter: ProductAttributeFilterInput
  $sort: ProductAttributeSortInput
  $pageSize: Int
  $currentPage: Int
) {
  products(
    search: $search
    filter: $filter
    sort: $sort
    pageSize: $pageSize
    currentPage: $currentPage
  ) {

    aggregations {
      attribute_code
      count
      label
      options {
        count
        label
        value
      }
      position
    }
    
  }
}
`,
  asideCategories: `query getCategories($filters: CategoryFilterInput) {
    categories(filters: $filters) {
        __typename
        items {
            children {
                breadcrumbs {
                    ...BreadcrumbFields
                }
                ...CategoryTreeFields
                children {
                    breadcrumbs {
                        ...BreadcrumbFields
                    }
                    ...CategoryTreeFields
                    children {
                        breadcrumbs {
                            ...BreadcrumbFields
                        }
                        ...CategoryTreeFields
                    }
                }
            }
            ...CategoryTreeFields
        }
    }
}fragment CategoryTreeFields on CategoryTree {
    uid
    icon_image
    product_count
    name
    url_key
    url_path
    image
    
}
fragment BreadcrumbFields on Breadcrumb {
    category_level
    category_name
    category_uid
    category_url_key
    category_url_path
}`,
  detail_products: `
query getProductDetail($url: String!) {
  route(url: $url) {
    __typename
    type
    ...ProductInterfaceField
    ... on SimpleProduct {
      related_products {
        ...ProductInterfaceField
      }
      crosssell_products {
        __typename
        sku
        id
        uid
        name
        url_key
        stock_status
        rating_summary
        review_count
        thumbnail {
          ...ProductImageFields
        }
        price_range {
          ...PriceRangeField
        }
        ...CustomField
        ...ConfigurableProductField
      }
      upsell_products {
        name
        sku
        url_key
        price_range {
          ...PriceRangeField
        }
      }
      attribute_set_id
    }
    ... on ConfigurableProduct {
      ...ConfigurableProductField
      related_products {
        ...ProductInterfaceField
      }
      crosssell_products {
        __typename
        sku
        id
        uid
        name
        url_key
        stock_status
        rating_summary
        review_count
        thumbnail {
          position
          ...ProductImageFields
        }
        price_range {
          ...PriceRangeField
        }
        ...CustomField
        ...ConfigurableProductField
      }
      upsell_products {
        name
        sku
        url_key
        price_range {
          ...PriceRangeField
        }
      }
      attribute_set_id
    }
  }
}
fragment ProductInterfaceField on ProductInterface {
  __typename
  sku
  id
  uid
  name
  link_shopee
  link_tiktok
  url_key
  size_chart
  type_clothing
  size_chart_image
  sales_qty
  stock_status
  categories {
    __typename
    name
    breadcrumbs {
      category_level
      category_name
      category_uid
      category_url_path
    }
    url_key
    url_path
    level
    uid
    path
  }
  meta_title
  canonical_url
  meta_description
  meta_keyword
  description {
    ...ComplexTextValueFields
  }
  rating_summary
  review_count
  short_description {
    ...ComplexTextValueFields
  }
  thumbnail {
    position
    ...ProductImageFields
  }
  image {
    ...ProductImageFields
  }
  media_gallery {
    url
    position
    __typename
    ... on ProductVideo {
      video_content {
        media_type
        video_description
        video_metadata
        video_provider
        video_title
        video_url
      }
    }
  }
  price_range {
    ...PriceRangeField
  }
  ...CustomField
}
fragment CustomField on ProductInterface {
  daily_sale {
    sale_price
    end_date
    entity_id
    sale_qty
    start_date
    saleable_qty
    sold_qty
    title
    __typename
  }
}
fragment PriceRangeField on PriceRange {
  __typename
  maximum_price {
    ...ProductPriceField
  }
  minimum_price {
    ...ProductPriceField
  }
}
fragment ProductPriceField on ProductPrice {
  discount {
    ...ProductDiscountFields
  }
  final_price {
    ...MoneyFields
  }
  regular_price {
    ...MoneyFields
  }
}
fragment ComplexTextValueFields on ComplexTextValue {
  html
}
fragment ProductImageFields on ProductImage {
  url
}
fragment MoneyFields on Money {
  currency
  value
}
fragment ProductDiscountFields on ProductDiscount {
  amount_off
  percent_off
}
fragment ConfigurableProductField on ConfigurableProduct {
  configurable_options {
    attribute_code
    label
    uid
    attribute_uid
    position
    values {
      label
      uid
      default_label
      swatch_data {
        value
      }
    }
  }
  variants {
    attributes {
      code
      label
      uid
    }
    product {
      __typename
      special_price
      ...CustomField
      price_range {
        ...PriceRangeField
      }
      tier_prices {
        customer_group_id
        percentage_value
        qty
        value
        website_id
      }
      description {
        html
      }
      sku
      stock_status
      name
      url_key
      image {
        disabled
        label
        position
        url
      }
      media_gallery {
        url
        position
        __typename
        ... on ProductVideo {
          video_content {
            media_type
            video_description
            video_metadata
            video_provider
            video_title
            video_url
          }
        }
      }
    }
  }
}
`,
}
